var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2907_1217)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2907_1217)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2907_1217",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 22.9167C13.8679 22.9183 15.2229 22.6497 16.4869 22.1261C17.751 21.6025 18.8991 20.8343 19.8653 19.8656C20.834 18.8994 21.6022 17.7513 22.1258 16.4872C22.6494 15.2232 22.918 13.8682 22.9163 12.5C22.918 11.1318 22.6494 9.77677 22.1258 8.51274C21.6022 7.24871 20.834 6.1006 19.8653 5.13436C18.8991 4.1657 17.751 3.3975 16.4869 2.8739C15.2229 2.35031 13.8679 2.08163 12.4997 2.08332C11.1315 2.08163 9.77647 2.35031 8.51244 2.8739C7.24841 3.3975 6.10029 4.1657 5.13406 5.13436C4.16539 6.1006 3.39719 7.24871 2.8736 8.51274C2.35 9.77677 2.08133 11.1318 2.08302 12.5C2.08133 13.8682 2.35 15.2232 2.8736 16.4872C3.39719 17.7513 4.16539 18.8994 5.13406 19.8656C6.10029 20.8343 7.24841 21.6025 8.51244 22.1261C9.77647 22.6497 11.1315 22.9183 12.4997 22.9167Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 12.5L11.458 15.625L17.708 9.375",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2907_1217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0V0Z",
    fill: "#414141"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2907_1217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2907_1217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBlack);
export default __webpack_public_path__ + "static/media/CheckBlack.5726297890fac10a98e4fad56208b950.svg";
export { ForwardRef as ReactComponent };